import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueAnalytics', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/analytics/issues-analytics/issues-analytics.html'),
        controller: 'IssueAnalyticsController',
        controllerAs: 'IssueAnalyticsCtrl',
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/issues-analytics/issues-analytics.component.ts